import { InjectionToken, Signal } from '@angular/core';

/**
 * Abstract DI seam so core/navigation can read the agency "reach" scope without
 * importing the agency feature (which would invert the layer direction).
 * Implemented by AgencyOrgService and wired in app.config via `useExisting`.
 */
export interface AgencyReach {
  /** owner/admin/principal — sees the whole agency. */
  readonly fullReach: Signal<boolean>;
  /** business manager — sees their own team. */
  readonly teamReach: Signal<boolean>;
}

export const AGENCY_REACH = new InjectionToken<AgencyReach>('AGENCY_REACH');
